import React from 'react';
import PropTypes from 'prop-types';

import './ExpandIcon.scss';

const ExpandIcon = ({ isActive }) => {
    const activeStyle = isActive ? 'active' : '';
    return (
        <svg
            className={`component-ExpandIcon ${activeStyle}`}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.2929 0.292893C14.6834 -0.0976306 15.3166 -0.0976305 15.7071 0.292893C16.0976 0.683417 16.0976 1.31658 15.7071 1.70711L8.70711 8.70711C8.31658 9.09763 7.68342 9.09763 7.29289 8.70711L0.292894 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292894 0.292893C0.683418 -0.0976312 1.31658 -0.0976311 1.70711 0.292893L8 6.58579L14.2929 0.292893Z"
                fill="#353535"
            />
        </svg>
    );
};

ExpandIcon.propTypes = {
    isActive: PropTypes.bool,
};

ExpandIcon.defaultProps = {
    isActive: false,
};

ExpandIcon.displayName = 'ExpandIcon';

export default ExpandIcon;
